export default __webpack_public_path__ + "static/media/symptobot.f6093d6e.png";